<tilby-dialog-toolbar title="ITEMS.SCALE_IMPORT.TITLE" [hideConfirm]="true" />
<tilby-dialog-content class="tw-min-w-[350px] md:tw-min-w-[450px] tw-max-h-[60vh] tw-flex tw-flex-col tw-gap-4">
	@if (globalError()) {
		<div class="tw-bg-red-50 tw-border-l-4 tw-border-red-400 tw-p-4 tw-rounded tw-flex tw-items-start tw-gap-3">
			<mat-icon class="tw-text-red-500 tw-flex-shrink-0">error_outline</mat-icon>
			<div class="tw-flex tw-flex-col">
				<span class="tw-font-semibold tw-text-red-800 tw-text-sm" translate="ITEMS.SCALE_IMPORT.ERROR.TITLE"></span>
				<span class="tw-text-red-700 tw-text-xs" [translate]="'ITEMS.SCALE_IMPORT.ERROR.' + globalError()"></span>
			</div>
		</div>
	}

	<div class="tw-flex tw-items-center">
		<div class="tw-text-gray-600 tw-text-sm" translate="ITEMS.SCALE_IMPORT.PRICE_LIST"></div>
	</div>
	<mat-form-field>
		<mat-select class="tw-w-full" [(ngModel)]="selectedPriceList">
			@for (priceList of priceLists; track priceList.index) {
				<mat-option [value]="priceList.index">{{ priceList.value }}</mat-option>
			}
		</mat-select>
	</mat-form-field>

	<div class="tw-flex tw-items-center">
		<div class="tw-text-gray-600 tw-text-sm" translate="ITEMS.SCALE_IMPORT.PREVIEW"></div>
	</div>

	<div class="tw-flex tw-flex-col">
		<div class="tw-overflow-y-auto tw-max-h-[35vh] tw-pr-1 tw-border tw-border-gray-200 tw-rounded-lg tw-bg-gray-50/30">
			<ul class="tw-p-0 tw-m-0 tw-list-none tw-divide-y tw-divide-gray-100">
				<li class="tw-px-3 tw-py-2.5 hover:tw-bg-gray-50 tw-transition-colors tw-flex tw-items-center">
					<mat-checkbox 
						[checked]="areAllScalesChecked()" 
						[indeterminate]="isSomeScalesChecked()" 
						[disabled]="inProgress()"
						(change)="changeAllScalesSelection($event.checked)">
						<div class="tw-flex tw-flex-col tw-ml-2">
							<span class="tw-font-semibold tw-text-sm" translate="ITEMS.SCALE_IMPORT.ACTION.SELECT_ALL"></span>
						</div>
					</mat-checkbox>
				</li>
				@for(scale of scales; track scale.ip_address){
					<li class="tw-px-3 tw-py-2.5 hover:tw-bg-gray-50 tw-transition-colors tw-flex tw-items-center tw-justify-between tw-gap-4">
						<mat-checkbox class="column-list" [(ngModel)]="scale.isChecked" [disabled]="inProgress()">
							<div class="tw-flex tw-flex-col tw-ml-2">
								<span class="tw-font-semibold tw-text-sm tw-text-gray-800">{{ scale.name }}</span>
								<span class="tw-text-xs tw-text-gray-500">{{ scale.type }} &bull; {{ scale.ip_address }}</span>
							</div>
						</mat-checkbox>

						@if (scale.status) {
							<div class="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-font-medium">
								@if (scale.status === 'loading') {
									<mat-icon class="tw-animate-spin tw-text-blue-500 tw-scale-75">sync</mat-icon>
								} @else if (scale.status === 'success') {
									<div class="tw-flex tw-items-center tw-gap-1.5 tw-cursor-help" [matTooltip]="getTranslationKeyForExitCode(scale.exitCode) | translate">
										<mat-icon class="tw-text-green-500 tw-scale-75">check_circle</mat-icon>
									</div>
								} @else if (scale.status === 'error') {
									<div class="tw-flex tw-items-center tw-gap-1.5 tw-cursor-help" [matTooltip]="getTranslationKeyForExitCode(scale.exitCode, scale.errorMessage) | translate">
										<mat-icon class="tw-text-red-500 tw-scale-75">{{ getIconForScale(scale) }}</mat-icon>
									</div>
								}
							</div>
						}
					</li>
				}
			</ul>
		</div>
	</div>

	<div class="tw-flex tw-justify-end tw-gap-3 tw-mt-2">
		<button mat-stroked-button color="primary" (click)="downloadPLUs()" 
			[disabled]="isNoScaleSelected() || inProgress()">
			@if (downloadInProgress()) {
				<mat-icon class="tw-animate-spin">sync</mat-icon>
			} @else {
				<mat-icon>download</mat-icon>
			}
			<span translate="ITEMS.SCALE_IMPORT.ACTION.DOWNLOAD_CSV"></span>
		</button>
		<button mat-flat-button color="primary" (click)="import()"
			[disabled]="isNoScaleSelected() || inProgress()">
			@if (processInProgress()) {
				<mat-icon class="tw-animate-spin">sync</mat-icon>
			} @else {
				<mat-icon>upload</mat-icon>
			}
			<span translate="ITEMS.SCALE_IMPORT.ACTION.UPLOAD_CSV"></span>
		</button>
	</div>
</tilby-dialog-content>